import { render, staticRenderFns } from "./unapproved-for-plan-info-card.vue?vue&type=template&id=30c48a16&scoped=true&"
import script from "./unapproved-for-plan-info-card.vue?vue&type=script&lang=js&"
export * from "./unapproved-for-plan-info-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c48a16",
  null
  
)

export default component.exports